import { makeStyles } from "../../shared";

export const onePlayerStyles = makeStyles({
  container: {
    aspectRatio: "16 / 9",
  },
  hidden: { display: "none" },
});
